import { render, staticRenderFns } from "./XButton.vue?vue&type=template&id=1056350d&scoped=true&"
import script from "./XButton.vue?vue&type=script&lang=js&"
export * from "./XButton.vue?vue&type=script&lang=js&"
import style0 from "./XButton.vue?vue&type=style&index=0&id=1056350d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1056350d",
  null
  
)

export default component.exports